.overlay {
  position: fixed;
  inset: 0;
  background: rgba(5, 8, 11, 0.72);
  z-index: 50;
}

.content {
  position: fixed;
  z-index: 51;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: calc(100vw - 32px);
  max-height: calc(100dvh - 48px);
  display: flex;
  flex-direction: column;
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
}

.sm {
  max-width: 440px;
}
.md {
  max-width: 640px;
}
.lg {
  max-width: 920px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  padding: 20px 24px;
  border-bottom: 1px solid var(--border-subtle);
}

.title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 800;
  font-stretch: 110%;
  letter-spacing: -0.02em;
}

.description {
  margin: 6px 0 0;
  color: var(--text-secondary);
  font-size: 0.9375rem;
}

.close {
  display: grid;
  place-items: center;
  width: 36px;
  height: 36px;
  background: transparent;
  border: 0;
  color: var(--text-secondary);
  cursor: pointer;
}

.close:hover {
  color: var(--text-primary);
  background: var(--bg-elevated);
}

.body {
  padding: 24px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid var(--border-subtle);
}
